import type {Icon} from '@primer/octicons-react'
// eslint-disable-next-line import/no-namespace
import * as Octicons from '@primer/octicons-react'

import type {OcticonComponentName, OcticonName} from '../types'

/**
 * Valid octicon names for navigation items (breadcrumbs and tabs)
 */
function octiconNameToComponentName(iconName: OcticonName): OcticonComponentName {
  return `${iconName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')}Icon` as OcticonComponentName
}

/**
 * Get the octicon component for a navigation item.
 * @param iconName - The name of the icon to retrieve
 * @returns The octicon React component, or undefined if not found
 */
export function getOcticon(iconName?: OcticonName): Icon | undefined {
  const IconName = iconName ? octiconNameToComponentName(iconName) : undefined

  const icon = IconName ? Octicons[IconName] : undefined

  if (iconName && !icon) {
    // Report missing icon to Failbot, but don't block rendering
    let errorMessage = `Octicon not found: ${iconName}`

    // use a more detailed error message in non-production environments
    if (process.env.NODE_ENV !== 'production') {
      errorMessage = `Octicon "${iconName}" is not a recognized icon in @primer/octicons-react. Please ensure a valid octicon name.`
    }

    setTimeout(() => {
      throw new Error(errorMessage)
    }, 0)
  }

  return icon
}
